module.exports = __webpack_public_path__ + "img/header.40128f6b.png";